import React, { useEffect, useState } from 'react';
import AdminSearchBarHeader from '../component/AdminSearchBarHeader';
import {
  Breadcrumb,
  Button,
  Card,
  Checkbox,
  Col,
  Image,
  Input,
  Radio,
  Row,
  Select,
  Spin,
  Upload,
  message,
} from 'antd';
import routes from '../../../controller/Routes';
import {
  Link,
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import { Icons } from '../../../controller/Images';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { CloseOutlined } from '@ant-design/icons';
import { useUserStore } from '../../../store/userReducer';
import { Section } from '../../../controller/enum';
import { getTechnology } from '../../../controller/api/globalServices';
import { createQuestion, getQuestionById, UpdateQuestionById } from '../../../controller/api/questionServices';
import { getAdminDetail } from '../../../controller/localStroageHandler';
const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
const AddAndEditQuestion = () => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useUserStore((state) => state);
  const [previewImage, setPreviewImage] = useState('');
  const [fileList, setFileList] = useState([]);
  const [isHovered, setIsHovered] = useState('');
  const [question, setQuestion] = useState(null);
  const [answer, setAnswer] = useState([]);
  const [dificulty, setDificulty] = useState('easy');
  const [choice, setChoice] = useState('single_choice');
  const [selectTechnology, setSelectTechnology] = useState([]);
  const [technologyList, setTechnologyList] = useState([]);
  const [loading, setloading] = useState(false);
  const [sectionList, setSectionList] = useState([]);
  const [section, setSection] = useState("");
  const [optionData, setOptionData] = useState([
    {
      option: null,
      fileList: [],
      previewImage: '',
    },
  ]);
  let userDetail = getAdminDetail()
  useEffect(() => {
    let data = Object.entries(Section);
    let sectionData = data.map((val) => {
      return { key: val[0], label: val[1] }
    })
    setSectionList(sectionData)
    getTechnologyData({ search: '' })
    if(params.id){
      getQuesByID()
    }
  }, [])
  const getTechnologyData = async (params) => {
    await getTechnology(params).then(res => {
      setTechnologyList(res?.data?.result)
    }).catch(err => {
      console.log("err ===>", err)
    })

  }

  const getQuesByID=()=>{
    getQuestionById({ id: userDetail?.organization_id?._id, quesId: params?.id }).then(res => {
      const { difficulty, imageUrl, options, questionType, section, technology, title } = res?.data?.data;
      console.log(res?.data?.data, "ddkndkndk")
      setSelectTechnology(technology)
      setQuestion(title)
      setDificulty(difficulty)
      setChoice(questionType)
      setPreviewImage(imageUrl)
      setSection(section)
      let answerList = [];
      const optionItem = options?.map((val, index) => {
        if (val?.is_answer == true || val?.is_answer == 'True') {
          answerList = [...answerList, index];
        }
        return {
          option: val?.text,
          fileList: [],
          previewImage: val?.image_url,
        };
      });
      setAnswer(answerList);
      setOptionData(optionItem);
      setloading(false);

    }).catch(err => {
      console.log("err ===>", err)
    })
  }
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file);
    }
    setPreviewImage(file.url || file.preview);
  };
  const handleOptionInput = (e, index) => {
    let data = [...optionData];
    data[index].option = e.target.value;
    setOptionData(data);
  };

  const uploadOptionImage = async (val, index) => {
    let data = [...optionData];
    data[index].fileList = val.fileList;
    if (!val.file.url && !val.file.preview) {
      val.file.preview = await getBase64(val.file);
    }
    data[index].previewImage = val.file.url || val.file.preview;
    setOptionData(data);
  };
  const handleAddOption = () => {
    setOptionData([
      ...optionData,
      {
        option: null,
        fileList: [],
        previewImage: '',
      },
    ]);
  };



  const handleSubmit = () => {
    const payload = {
      title: question,
      technology: selectTechnology?.map((val) => val._id),
      difficulty: dificulty,
      questionType: choice,
      imageUrl: previewImage,
      section: section,
      options: optionData
        ?.filter((item) => {
          if (item?.option != null) {
            return item;
          }
        })
        ?.map((val, index) => {
          return {
            is_answer: answer.includes(index),
            text: val.option,
            image_url: val.previewImage,
          };
        }),
    };
    if (payload?.title == null) {
      return message.info('Please provide a title.');
    }
    if (payload?.options?.length < 2) {
      return message.info('please add minimum 2 options with option text');
    }
    const checkAnswer = payload?.options?.filter((val) => {
      if (val.is_answer) {
        return val;
      }
    });
    if (checkAnswer?.length == 0) {
      return message.info('please select the answer');
    }
    if (payload?.technology?.length == 0) {
      return message.info('please add Technology');
    }
    if (payload?.section == "") {
      return message.info("please add the section")
    }
    if (params?.id) {
      UpdateQuestionById(payload,{ id: userDetail?.organization_id?._id,quesId:params?.id })
        .then((res) => {
          message.success('Question Sucessfully Updated!');
          navigate(-1);
        })
        .catch((err) => console.log('err=====> ', err));
    } else {
      createQuestion(payload, { id: userDetail?.organization_id?._id })
        .then((res) => {
          message.success(res?.data?.message);
          navigate(-1);
        })
        .catch((err) => {
          console.log('err =======>', err);
        });
    }
  };
  return (
    <div className='w-100 h-100 p-4 bg-light overflow-y-auto'>
      <AdminSearchBarHeader />
      <Row align={'middle'} className='mt-2 mb-2'>
        <Col span={24} className='fs-5 fw-semibold'>
          <Breadcrumb
            items={[
              {
                title: (
                  <Link
                    to={routes.admin.dashboard.questionnaire.self}
                    className='text-decoration-none text-capitalize'
                  >
                    questionnaire
                  </Link>
                ),
              },
              {
                title: (
                  <div className='text-capitalize'>
                    {location.pathname?.split('/')[4]}
                  </div>
                ),
              },
            ]}
          />
        </Col>
      </Row>
      <Card>
        <Spin spinning={loading}>
          <Row gutter={[12, 12]}>
            <Col xl={15} lg={15} md={18} sm={20} xs={24}>
              <div className='d-flex justify-content-center align-items-center gap-3'>
                <Input
                  onChange={(e) => setQuestion(e.target.value)}
                  className=' border  border-0 border-bottom bg-light text-black-50 fw-medium'
                  placeholder='Untitled Question'
                  value={question}
                />
                <Upload
                  maxCount={1}
                  beforeUpload={(file) => false}
                  showUploadList={false}
                  fileList={fileList}
                  onChange={(val) => {
                    handlePreview(val.file);
                    setFileList(val?.fileList);
                  }}
                >
                  <Image
                    src={Icons.imageIcon}
                    preview={false}
                    style={{ cursor: 'pointer' }}
                  />
                </Upload>
              </div>
            </Col>
            <Col xl={9} lg={9} md={6} sm={20} xs={24}>
              <Select
                className='w-100'
                value={choice}
                onChange={(val) => {
                  setAnswer([]);
                  setChoice(val);
                }}
              >
                <Select.Option value={'multiple_choice'}>
                  Multiple Choice
                </Select.Option>
                <Select.Option value={'single_choice'}>
                  Single Choice
                </Select.Option>
              </Select>
            </Col>
            <Col span={24}>
              {previewImage !== '' && (
                <Image
                  src={previewImage}
                  className='rounded-3 image-customization'
                  height={300}
                  preview={{
                    mask: (
                      <div className='d-flex gap-4 fs-6 fw-semibold'>
                        <span>Preview</span>
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            setPreviewImage('');
                            setFileList([]);
                          }}
                        >
                          <FontAwesomeIcon
                            style={{ cursor: 'pointer' }}
                            icon={faTrashCan}
                          />
                        </span>
                      </div>
                    ),
                  }}
                />
              )}
            </Col>
            <Col xl={15} lg={15} md={18} sm={20} xs={24}>
              {choice == 'single_choice' ? (
                <Row gutter={[12, 12]} className='w-100'>
                  <Radio.Group
                    className='w-100'
                    onChange={(val) => setAnswer([val.target.value])}
                    value={answer[0]}
                  >
                    <Row gutter={[12, 15]}>
                      {optionData?.map((val, index) => {
                        return (
                          <Col
                            key={index}
                            span={24}
                            onMouseEnter={() => {
                              setIsHovered(index);
                            }}
                            onMouseLeave={() => setIsHovered('')}
                          >
                            <div className='d-flex w-100 align-items-center gap-2'>
                              <div className='border border-0 border-bottom p-1'>
                                <Radio value={index} checked={true}>
                                  <Input
                                    className='border  border-0  text-black-50 fw-medium option-input'
                                    placeholder={`Option ${index + 1}`}
                                    value={val.option}
                                    onChange={(e) =>
                                      handleOptionInput(e, index)
                                    }
                                  />
                                </Radio>
                                <Upload
                                  maxCount={1}
                                  beforeUpload={() => false}
                                  showUploadList={false}
                                  fileList={val.fileList}
                                  style={{ pointerEvents: 'none' }}
                                  onChange={(val) =>
                                    uploadOptionImage(val, index)
                                  }
                                >
                                  <Image
                                    src={Icons.imageIcon}
                                    preview={false}
                                    style={{ cursor: 'pointer' }}
                                  />
                                </Upload>
                              </div>
                              {isHovered == index &&
                                isHovered !== '' &&
                                optionData?.length > 1 && (
                                  <FontAwesomeIcon
                                    style={{ cursor: 'pointer' }}
                                    icon={faTrashCan}
                                    onClick={() => {
                                      const data = optionData.filter(
                                        (item, indexNumber) =>
                                          index !== indexNumber
                                      );
                                      setOptionData(data);
                                      if (answer == index) {
                                        setAnswer('');
                                      }
                                    }}
                                  />
                                )}
                            </div>
                            {val.previewImage !== '' && (
                              <Image
                                src={val.previewImage}
                                className='rounded-3 image-customization mt-2 mb-2'
                                height={200}
                                preview={{
                                  mask: (
                                    <div className='d-flex gap-4 fs-6 fw-semibold'>
                                      <span>Preview</span>
                                      <span
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          let data = [...optionData];
                                          data[index].fileList = [];
                                          data[index].previewImage = '';
                                          setOptionData(data);
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          style={{ cursor: 'pointer' }}
                                          icon={faTrashCan}
                                        />
                                      </span>
                                    </div>
                                  ),
                                }}
                              />
                            )}
                          </Col>
                        );
                      })}
                    </Row>
                  </Radio.Group>
                  <Col span={24}>
                    <div className='d-flex align-items-center'>
                      <Radio
                        className='border  border-0 border-bottom p-1'
                        disabled
                      >
                        Add option or{' '}
                        <Button
                          type='text'
                          className=' p-0 m-0 text-color-custom fw-normal bg-transparent custom-hover-btn-color'
                          onClick={() => handleAddOption()}
                        >
                          Add "Other"
                        </Button>
                      </Radio>
                    </div>
                  </Col>
                </Row>
              ) : (
                <Row gutter={[12, 12]} className='w-100'>
                  <Checkbox.Group
                    className='w-100'
                    onChange={(val) => setAnswer(val)}
                    value={answer}
                  >
                    <Row gutter={[12, 15]}>
                      {optionData?.map((val, index) => {
                        return (
                          <Col
                            key={index}
                            span={24}
                            onMouseEnter={() => {
                              setIsHovered(index);
                            }}
                            onMouseLeave={() => setIsHovered('')}
                          >
                            <div className='d-flex w-100 align-items-center gap-2'>
                              <div className='border border-0 border-bottom p-1'>
                                <Checkbox value={index}>
                                  <Input
                                    className='border  border-0  text-black-50 fw-medium option-input'
                                    placeholder={`Option ${index + 1}`}
                                    value={val.option}
                                    onChange={(e) =>
                                      handleOptionInput(e, index)
                                    }
                                  />
                                </Checkbox>
                                <Upload
                                  maxCount={1}
                                  beforeUpload={() => false}
                                  showUploadList={false}
                                  fileList={val.fileList}
                                  style={{ pointerEvents: 'none' }}
                                  onChange={(val) =>
                                    uploadOptionImage(val, index)
                                  }
                                >
                                  <Image
                                    src={Icons.imageIcon}
                                    preview={false}
                                    style={{ cursor: 'pointer' }}
                                  />
                                </Upload>
                              </div>
                              {isHovered == index &&
                                isHovered !== '' &&
                                optionData?.length > 1 && (
                                  <FontAwesomeIcon
                                    style={{ cursor: 'pointer' }}
                                    icon={faTrashCan}
                                    onClick={() => {
                                      const data = optionData.filter(
                                        (item, indexNumber) =>
                                          index !== indexNumber
                                      );
                                      setOptionData(data);
                                      const filterAnswer = answer.filter(
                                        (val) => val !== index
                                      );
                                      setAnswer(filterAnswer);
                                    }}
                                  />
                                )}
                            </div>
                            {val.previewImage !== '' && (
                              <Image
                                src={val.previewImage}
                                className='rounded-3 image-customization mt-2 mb-2'
                                height={200}
                                preview={{
                                  mask: (
                                    <div className='d-flex gap-4 fs-6 fw-semibold'>
                                      <span>Preview</span>
                                      <span
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          let data = [...optionData];
                                          data[index].fileList = [];
                                          data[index].previewImage = '';
                                          setOptionData(data);
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          style={{ cursor: 'pointer' }}
                                          icon={faTrashCan}
                                        />
                                      </span>
                                    </div>
                                  ),
                                }}
                              />
                            )}
                          </Col>
                        );
                      })}
                    </Row>
                  </Checkbox.Group>
                  <Col span={24}>
                    <div className='d-flex align-items-center'>
                      <Checkbox
                        className='border  border-0 border-bottom p-1'
                        disabled
                      >
                        Add option or{' '}
                        <Button
                          type='text'
                          className=' p-0 m-0 text-color-custom fw-normal bg-transparent custom-hover-btn-color'
                          onClick={() => handleAddOption()}
                        >
                          Add "Other"
                        </Button>
                      </Checkbox>
                    </div>
                  </Col>
                </Row>
              )}
            </Col>
            <Col xl={15} lg={15} md={18} sm={20} xs={24} className='lh-lg'>
              <span className='fw-medium fs-6'>Technology Used</span>
              <div className='border border-0 border-bottom d-flex p-1'>
                <div className='d-flex gap-2 flex-wrap'>
                  {selectTechnology?.map((val, index) => {
                    return (
                      <span
                        key={index}
                        className='skill-bg-color text-muted rounded-1 d-flex gap-1'
                        style={{ fontSize: '14px', padding: '0px 5px' }}
                      >
                        {val?.name}
                        <CloseOutlined
                          onClick={() => {
                            const data = selectTechnology?.filter(
                              (item) => val._id !== item._id
                            );
                            setSelectTechnology(data);
                          }}
                        />
                      </span>
                    );
                  })}
                  <span>
                    <Input
                      className='border border-0  text-black-50 fw-medium option-input'
                      placeholder='add technology '
                      onChange={(e) => { getTechnologyData({ search: e.target.value }) }}
                    />
                  </span>
                </div>
              </div>
              <div className='d-flex gap-2 flex-wrap p-1'>
                {technologyList?.map((val, index) => {
                  return (
                    <span
                      key={index}
                      className='skill-bg-color text-muted rounded-1 d-flex gap-1'
                      style={{
                        fontSize: '14px',
                        padding: '0px 5px',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        let checkTechology = selectTechnology.filter(
                          (item) => val._id == item._id
                        );
                        if (checkTechology?.length) {
                          message.info('You Already Selected This Technology');
                        } else {
                          setSelectTechnology([...selectTechnology, val]);
                        }
                      }}
                    >
                      {val?.name}
                    </span>
                  );
                })}
              </div>
            </Col>
            <Col xl={15} lg={15} md={18} sm={20} xs={24} className='lh-lg'>
              <span className='fw-medium fs-6'>Section</span>
              <Select
                className='w-100'
                value={section}
                onChange={(val) => {
                  setSection(val)
                }}
              >
                {sectionList?.map((val, index) => {
                  return (
                    <Select.Option value={val?.key} key={index}>
                      {val?.label}
                    </Select.Option>
                  );
                })}
              </Select>
            </Col>
            <Col span={24}>
              <Row gutter={[12, 12]}>
                <Col xl={15} lg={14} md={12} sm={12} xs={24} className=''>
                  <div className='fw-medium fs-6 text-muted'>
                    Set Difficulty
                  </div>
                  <div className='diff-radio-btn mt-2'>
                    <Radio.Group
                      className='d-flex gap-2 border-0'
                      value={dificulty}
                      onChange={(e) => setDificulty(e.target.value)}
                    >
                      <Radio.Button
                        className='radio-btn-bg-color text-muted border-0 rounded-0 fw-normal'
                        value={'easy'}
                      >
                        Easy
                      </Radio.Button>
                      <Radio.Button
                        className='radio-btn-bg-color text-muted border-0 fw-normal'
                        value={'medium'}
                      >
                        Medium
                      </Radio.Button>
                      <Radio.Button
                        className='radio-btn-bg-color text-muted border-0 rounded-0 fw-normal'
                        value={'hard'}
                      >
                        Hard
                      </Radio.Button>
                    </Radio.Group>
                  </div>
                </Col>
                <Col xl={9} lg={10} md={12} sm={12} xs={24}>
                  <Row
                    gutter={[12, 12]}
                    className='h-100 d-flex align-items-end'
                  >
                    <Col span={12}>
                      <Button
                        type='default'
                        className='text-color-custom w-100 fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center custom-hover-btn'
                        onClick={() =>
                          navigate(routes.admin.dashboard.questionnaire.self)
                        }
                      >
                        Discard
                      </Button>
                    </Col>
                    <Col span={12}>
                      <Button
                        type='primary'
                        className=' w-100 fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center button-color custom-hover-btn'
                        onClick={() => handleSubmit()}
                      >
                        Save
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Spin>
      </Card>
    </div>
  );
};

export default AddAndEditQuestion;
